import { useEffect, useState } from 'react';
import './App.css';
import { supabase } from './lib/supabase';
import { t } from './lib/i18n';
import LoginPage from './pages/LoginPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import MainPage from './pages/MainPage';
import SharePage from './pages/SharePage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import { checkAndNotify } from './lib/notifications';

function getShareToken() {
  const match = window.location.pathname.match(/^\/share\/([A-Za-z0-9]+)$/);
  return match ? match[1] : null;
}

function getPublicPage() {
  const path = window.location.pathname;
  if (path === '/privacy') return 'privacy';
  if (path === '/terms') return 'terms';
  return null;
}

function App() {
  const isPrerendering = typeof navigator !== 'undefined' && navigator.userAgent === 'ReactSnap';
  const [session, setSession] = useState(isPrerendering ? null : undefined);
  const [isRecovery, setIsRecovery] = useState(false);
  const shareToken = getShareToken();
  const publicPage = getPublicPage();

  // 다크모드 초기 적용
  useEffect(() => {
    if (localStorage.getItem('lifelog_dark') === 'true') {
      document.body.classList.add('dark-mode');
    }
  }, []);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setSession(session);

      // 비밀번호 재설정 링크로 접속한 경우
      if (event === 'PASSWORD_RECOVERY') {
        setIsRecovery(true);
        return;
      }

      // 로그인 성공 후 공유 페이지 리다이렉트
      if (session) {
        const redirect = localStorage.getItem('lifelog_share_redirect');
        if (redirect) {
          localStorage.removeItem('lifelog_share_redirect');
          window.location.href = redirect;
        }
      }
    });

    return () => subscription.unsubscribe();
  }, []);

  // 공개 페이지 (로그인 불필요)
  if (shareToken) return <SharePage token={shareToken} />;
  if (publicPage === 'privacy') return <PrivacyPage />;
  if (publicPage === 'terms') return <TermsPage />;

  if (session === undefined) {
    return (
      <div className="splash-screen">
        <div className="splash-logo">📖</div>
        <h1 className="splash-title">인생로그</h1>
        <p className="splash-subtitle">{t('splash_loading')}</p>
        <div className="splash-dots">
          <span className="splash-dot" />
          <span className="splash-dot" />
          <span className="splash-dot" />
        </div>
      </div>
    );
  }

  // 비밀번호 재설정 모드
  if (isRecovery && session) {
    return <ResetPasswordPage onDone={() => setIsRecovery(false)} />;
  }

  if (!session) return <LoginPage />;

  // 로그인 후 알림 체크
  checkAndNotify(session.user.id);

  return <MainPage user={session.user} />;
}

export default App;
